"use client";
import React, { useRef, useState, useEffect } from "react";
import { Box, Icon } from "@chakra-ui/react";
import Image from "next/image";
import { CgPlayButtonO } from "@onemind-services-llc/react-icons-ng/cg";
import Thumbnail from "public/homevideo/VideoThumbnail.png";

const VideoPlayerWithOverlay = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    if (showVideo) {
      videoRef.current?.play();
    }
  }, [showVideo]);

  const handlePlay = () => {
    setShowVideo(true);
  };

  return (
    <Box position="relative" width="100%" maxW="645px" maxH="360px">
      {!showVideo ? (
        <Box>
          <Image
            src={Thumbnail}
            alt="Video Thumbnail"
            style={{ objectFit: "cover", width: "100%", height: "100%" }}
          />
          <Box
            position="absolute"
            top="0"
            left="0"
            width="100%"
            height="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
            zIndex="1"
          >
            <Icon
              as={CgPlayButtonO}
              w={16}
              h={16}
              zIndex="2"
              aria-label="Play Button"
              cursor="pointer"
              onClick={handlePlay}
              position="absolute"
              color="white"
            />
          </Box>
        </Box>
      ) : (
        <video
          ref={videoRef}
          width="100%"
          height="100%"
          style={{ maxHeight: "360px", maxWidth: "645px" }}
          controls
        >
          <source src="/homevideo/OmsVideo.mp4" type="video/mp4" />
        </video>
      )}
    </Box>
  );
};

export default VideoPlayerWithOverlay;
